import { Product } from '../types'

export const productData: Product[] = [
  {
    id: "prod_RyA5YvK0jSeYhN",
    name: "ETF Blend 100-20",
    price: 199.00,
    features: [
      { text: "Annualized return: 48.7%", included: true },
      { text: "Expected Monthly Return: 3.3%", included: true },                    
      { text: "Max Drawdown: 16.81%", included: true },
      { text: "Sharpe: 1.47", included: true },
      { text: "Sortino: 3.07", included: true },
      { text: "Calmar: 2.9", included: true }
    ],
    reportSlug: "etf-blend-100-20",
    reportBeginDate: "10 Sep, 2014",
    reportEndDate: "21 Apr, 2025",
    recommended: false
  },
  {
    id: "prod_RyA5TW7eerrzBF",
    name: "ETF Blend 101-15",
    price: 199.00,
    features: [
      { text: "Annualized return: 23.17%", included: true },
      { text: "Expected Monthly Return: 1.73%", included: true },                    
      { text: "Max Drawdown: 10.09%", included: true },
      { text: "Sharpe: 1.76", included: true },
      { text: "Sortino: 2.69", included: true },
      { text: "Calmar: 2.3", included: true }
    ],
    reportSlug: "etf-blend-101-15",
    reportBeginDate: "30 Dec, 2013",
    reportEndDate: "21 Apr, 2025",
    recommended: false
  },
  {
    id: "prod_RyA6R3YATtx5ny",
    name: "ETF Blend 102-25",
    price: 249.00,
    features: [
      { text: "Annualized return: 61.56%", included: true },
      { text: "Expected Monthly Return: 4.03%", included: true },                    
      { text: "Max Drawdown: 10.93%", included: true },
      { text: "Sharpe: 2.04", included: true },
      { text: "Sortino: 5.62", included: true },
      { text: "Calmar: 5.63", included: true }
    ],
    reportSlug: "etf-blend-102-25",
    reportBeginDate: "26 Jun, 2015",
    reportEndDate: "21 Apr, 2025",
    recommended: false
  },
  {
    id: "prod_RyA6y1etkxsldr",
    name: "ETF Blend 200-35",
    price: 249.00,
    features: [
      { text: "Annualized return: 39.64%", included: true },
      { text: "Expected Monthly Return: 2.79%", included: true },                    
      { text: "Max Drawdown: 9.02%", included: true },
      { text: "Sharpe: 2.56", included: true },
      { text: "Sortino: 5.21", included: true },
      { text: "Calmar: 4.4", included: true }
    ],
    reportSlug: "etf-blend-200-35",
    reportBeginDate: "26 Jun, 2015",
    reportEndDate: "21 Apr, 2025",
    recommended: false
  },
  {
    id: "prod_RyA6rf4LYS5Ltj",
    name: "ETF Blend 300-40",
    price: 299.00,
    features: [
      { text: "Annualized return: 78.82%", included: true },
      { text: "Expected Monthly Return: 4.92%", included: true },                    
      { text: "Max Drawdown: 11.1%", included: true },
      { text: "Sharpe: 2.68", included: true },
      { text: "Sortino: 6.24", included: true },
      { text: "Calmar: 7.1", included: true }
    ],
    reportSlug: "etf-blend-300-40",
    reportBeginDate: "23 Sep, 2014",
    reportEndDate: "21 Apr, 2025",
    recommended: false
  },
  {
    id: "prod_RyA6bPSPODGIWi",
    name: "ETF Blend 301-20",
    price: 299.00,
    features: [
      { text: "Annualized return: 85.24%", included: true },
      { text: "Expected Monthly Return: 5.23%", included: true },                    
      { text: "Max Drawdown: 21.31%", included: true },
      { text: "Sharpe: 2.57", included: true },
      { text: "Sortino: 4.63", included: true },
      { text: "Calmar: 4.0", included: true }
    ],
    reportSlug: "etf-blend-301-20",
    reportBeginDate: "24 Apr, 2012",
    reportEndDate: "21 Apr, 2025",
    recommended: false
  }
]